import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

import DatePresenter, { SHORT_FORMAT } from '../../../presenters/DatePresenter';
import StorePresenter from '../../../presenters/StorePresenter';
import CashbackPresenter from '../../../presenters/CashbackPresenter';
import Label from '../../../components/Label';
import Group from '../../../components/Group';
import Row from '../../../components/Row';
import Column from '../../../components/Column';
import Input from '../../../components/Input';
import Select from '../../../components/Select';

const EditCashbackFormFields = (props) => {
  const { values, stores, onChange, onDateChange, errors } = props;
  const { date, amount, storeId, place } = values;
  const storeOptions = stores.map((store) => {
    return {
      label: StorePresenter.name(store),
      value: StorePresenter.id(store),
    };
  });
  const defaultStoreOption = { value: '', label: '-- select a store --' };

  const placeOptions = [
    { value: 'in store', label: 'in store' },
    { value: 'online', label: 'online' },
    { value: 'other', label: 'other' },
  ];

  return (
    <Group>
      <Row>
        <Column>
          <Label name="purchaseDate" title="Purchase Date" errors={errors} />
          <DatePicker
            id="date"
            selected={DatePresenter.dateObject(date)}
            onChange={(date) => onDateChange(date)}
            dateFormat="MM-dd-yyyy"
          />
        </Column>
        <Column>
          <Label name="amount" title="Amount" errors={errors} />
          <Input disabled id="amount" value={amount} onChange={onChange} />
        </Column>
        <Column>
          <Label name="place" title="Place" errors={errors} />
          <Select
            id="place"
            value={place}
            onChange={onChange}
            options={placeOptions}
            required
          />
        </Column>
      </Row>
      <Row>
        <Column className="cashback-field-column">
          <Label name="store" title="Store" errors={errors} />
          <Select
            id="storeId"
            options={storeOptions}
            defaultOption={defaultStoreOption}
            onChange={onChange}
            value={storeId}
            required
          />
        </Column>
      </Row>
    </Group>
  );
};

export default EditCashbackFormFields;

EditCashbackFormFields.propTypes = {
  values: CashbackPresenter.shape().isRequired,
  stores: PropTypes.arrayOf(StorePresenter.shape()).isRequired,
  onChange: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
};

EditCashbackFormFields.defaultProps = {
  errors: {},
};
